export default __webpack_public_path__ + "static/media/auth-logo-dark.b88b6a10.png";